export default {
    salesOrgData: [
        {
            region: {
                name: 'europe',
                abbrevation: 'emea',
                discription: 'Europe, Middle-East and Africa'
            },
            salesOrgList: [
                {
                    salesOrgCode: "GB03",
                    salesOrgAlias: "UK",
                    supportedLocales: [
                        { localeId: 2057, localeCode: 'en-GB' }
                    ]
                },
                {
                    salesOrgCode: "IE01",
                    salesOrgAlias: "IE",
                    supportedLocales: [
                        { localeId: 2057, localeCode: 'en-GB' }
                    ]
                },
                {
                    salesOrgCode: "CZ01",
                    salesOrgAlias: "CZ",
                    supportedLocales: [
                        { localeId: 1029, localeCode: 'cs-CZ' }
                    ]
                },
                {
                    salesOrgCode: "FR03",
                    salesOrgAlias: "FR",
                    supportedLocales: [
                        { localeId: 1036, localeCode: 'fr-FR' }
                    ]
                },
                {
                    salesOrgCode: "BE01",
                    salesOrgAlias: "BE",
                    supportedLocales: [
                        { localeId: 2060, localeCode: 'fr-BE' },
                        { localeId: 2067, localeCode: 'nl-BE' }
                    ]
                },
                {
                    salesOrgCode: "DE01",
                    salesOrgAlias: "DE",
                    supportedLocales: [
                        { localeId: 1031, localeCode: 'de-DE' }                        
                    ]
                },
                {
                    salesOrgCode: "NL02",
                    salesOrgAlias: "NL",
                    supportedLocales: [
                        { localeId: 1043, localeCode: 'nl-NL' }                        
                    ]
                },
                {
                    salesOrgCode: "ES01",
                    salesOrgAlias: "ES",
                    supportedLocales: [
                        { localeId: 1034, localeCode: 'es-ES' }                        
                    ]
                },
                {
                    salesOrgCode: "PT01",
                    salesOrgAlias: "PT",
                    supportedLocales: [
                        { localeId: 2070, localeCode: 'pt-PT' }                        
                    ]
                },
                {
                    salesOrgCode: "SK02",
                    salesOrgAlias: "SK",
                    supportedLocales: [
                        { localeId: 1051, localeCode: 'sk-SK' }                        
                    ]
                },
                {
                    salesOrgCode: "PL05",
                    salesOrgAlias: "PL",
                    supportedLocales: [
                        { localeId: 1045, localeCode: 'pl-PL' }
                    ]
                }
            ]
        },
        {
            region: {
                name: 'asia',
                abbrevation: 'apac',
                discription: 'Asia Pacific'
            },
            salesOrgList: [
                {
                    salesOrgCode: "CN01",
                    salesOrgAlias: "CN",
                    supportedLocales: [
                        { localeId: 0, localeCode: 'zh-CN' }                        
                    ]
                }
            ]
        },
        {
            region: {
                name: 'america',
                abbrevation: 'amer',
                discription: 'North, Central and South America.'
            },
            salesOrgList: [
                {
                    salesOrgCode: "US10",
                    salesOrgAlias: "US",
                    supportedLocales: [
                        { localeId: 1033, localeCode: 'en-US' }
                    ]
                }
            ]
        }
    ],
    brandData: [
        {
            salesOrgAlias: "DEFAULT",
            brandName: "AirProducts",
            headerLogo: "https://inc.airproducts.com/d/ap/v3/dist/img/ap_logo.png",
            headerLogoWidth: 206,
            hearderLogoHeight: 42,
            footerLogo: "https://inc.airproducts.com/d/ap/v3/dist/img/ap_logo.png",
            footerLogoWidth: 206,
            footerLogoHeight: 42
        },
        {
            salesOrgAlias: "ES",
            brandName: "Carburos",
            headerLogo: "https://inc.airproducts.com/d/ap/v3/dist/img/es_logo.png",
            headerLogoWidth: 193,
            hearderLogoHeight: 58,
            footerLogo: "https://www.airproducts.com/-/media/images/graphics/logos/carburos-logo-png.png",
            footerLogoWidth: 193,
            footerLogoHeight: 58
        },
        {
            salesOrgAlias: "PT",
            brandName: "Gasin",
            headerLogo: "https://inc.airproducts.com/d/ap/v3/dist/img/pt_logo.png",
            headerLogoWidth: 193,
            hearderLogoHeight: 52,
            footerLogo: "https://www.airproducts.com/-/media/images/graphics/logos/gasin-logo-png.png",
            footerLogoWidth: 193,
            footerLogoHeight: 52
        }
    ],
    countryUrlData: [
        {
            salesOrgAlias: "DEFAULT",
            aboutUs: "http://www.airproducts.com",
            contactUs: "https://www.airproducts.com/contact-us.aspx"    
        },
        {
            salesOrgAlias: "AE",
            aboutUs: "http://www.airproducts.me",
            contactUs: "https://www.airproducts.me/contact-us/form"
        },
        {
            salesOrgAlias: "AR",
            aboutUs: "http://www.indura.com.ar",
            contactUs: "https://www.indura.com.ar"
        },
        {
            salesOrgAlias: "BE|2060",
            aboutUs: "http://www.airproducts.be/fr",
            contactUs: "http://www.airproducts.be/fr/contact-us.aspx"
        },
        {
            salesOrgAlias: "BE|2067",
            aboutUs: "http://www.airproducts.be",
            contactUs: "http://www.airproducts.be/contact-us.aspx"
        },
        {
            salesOrgAlias: "CL",
            aboutUs: "http://www.indura.cl",
            contactUs: "https://www.indura.cl/Web/CL/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "CN",
            aboutUs: "http://www.airproducts.com.cn",
            contactUs: "http://www.airproducts.com.cn/contact-us.aspx"
        },
        {
            salesOrgAlias: "CO",
            aboutUs: "http://www.cryogas.com.co",
            contactUs: "https://www.cryogas.com.co/Web/CO/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "CZ",
            aboutUs: "http://www.airproducts.cz",
            contactUs: "http://www.airproducts.cz/contact-us"
        }, 
        {
            salesOrgAlias: "DE",
            aboutUs: "http://www.airproducts.de",
            contactUs: "http://www.airproducts.de/contact-us.aspx"
        },
        {
            salesOrgAlias: "EC",
            aboutUs: "http://www.indura.com.ec",
            contactUs: "https://www.indura.com.ec/Web/EC/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "ES",
            aboutUs: "http://www.carburos.com",
            contactUs: "http://www.carburos.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "FR",
            aboutUs: "http://www.airproducts.fr",
            contactUs: "http://www.airproducts.fr/contact-us.aspx"
        },
        {
            salesOrgAlias: "ID",
            aboutUs: "http://www.airproducts.co.id",
            contactUs: "http://www.airproducts.co.id/contact-us.aspx"
        },
        {
            salesOrgAlias: "IE",
            aboutUs: "http://www.airproducts.ie",
            contactUs: "https://airproducts-uk.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "IL",
            aboutUs: "http://www.airproducts.co.il",
            contactUs: "https://www.airproducts.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "IT",
            aboutUs: "http://www.airproducts.it",
            contactUs: "https://www.airproducts.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "KR",
            aboutUs: "http://www.airproducts.co.kr",
            contactUs: "https://microsites.airproducts.com/kr-contact-us/index.asp"
        },
        {
            salesOrgAlias: "MY",
            aboutUs: "http://www.airproducts.com.my",
            contactUs: "https://www.airproducts.com.my/customer-service"
        },
        {
            salesOrgAlias: "NL",
            aboutUs: "http://www.airproducts.nl",
            contactUs: "http://www.airproducts.nl/contact-us.aspx"
        },
        {
            salesOrgAlias: "OM",
            aboutUs: "http://www.airproducts.me",
            contactUs: "https://www.airproducts.me/contact-us/form"
        },
        {
            salesOrgAlias: "PE",
            aboutUs: "http://www.airproducts.com.pe",
            contactUs: "https://www.airproducts.com.pe/Web/PE/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "PL",
            aboutUs: "http://www.airproducts.pl",
            contactUs: "http://www.airproducts.com.pl/contact-us.aspx"
        },
        {
            salesOrgAlias: "PT",
            aboutUs: "http://www.gasin.com",
            contactUs: "http://www.gasin.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "SG",
            aboutUs: "http://www.airproducts.com.sg",
            contactUs: "http://www.airproducts.com.sg/contact-us.aspx"
        },
        {
            salesOrgAlias: "SK",
            aboutUs: "http://www.airproducts.sk",
            contactUs: "http://www.airproducts.sk/contact-us"
        },
        {
            salesOrgAlias: "TW",
            aboutUs: "http://www.airproducts.com.tw",
            contactUs: "http://www.airproducts.com.tw/contact-us.aspx"
        },
        {
            salesOrgAlias: "UK",
            aboutUs: "http://www.airproducts.co.uk",
            contactUs: "https://airproducts-uk.custhelp.com/app/ask"
        }
    ],
    oracleRightNow_CountryUrlData: [
        {
            salesOrgAlias: "DEFAULT",
            aboutUs: "http://www.airproducts.com",
            contactUs: "https://www.airproducts.com/contact-us.aspx"    
        },
        {
            salesOrgAlias: "AE",
            aboutUs: "http://www.airproducts.me",
            contactUs: "https://www.airproducts.me/contact-us/form"
        },
        {
            salesOrgAlias: "AR",
            aboutUs: "http://www.indura.com.ar",
            contactUs: "https://www.indura.com.ar"
        },
        {
            salesOrgAlias: "BE|2060",
            aboutUs: "http://www.airproducts.be/fr",
            contactUs: "https://airproducts-fr.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "BE|2067",
            aboutUs: "http://www.airproducts.be",
            contactUs: "https://airproducts-nl.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "CL",
            aboutUs: "http://www.indura.cl",
            contactUs: "https://www.indura.cl/Web/CL/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "CN",
            aboutUs: "http://www.airproducts.com.cn",
            contactUs: "http://www.airproducts.com.cn/contact-us.aspx"
        },
        {
            salesOrgAlias: "CO",
            aboutUs: "http://www.cryogas.com.co",
            contactUs: "https://www.cryogas.com.co/Web/CO/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "CZ",
            aboutUs: "http://www.airproducts.cz",
            contactUs: "https://airproducts-cz.custhelp.com/app/ask"
        }, 
        {
            salesOrgAlias: "DE",
            aboutUs: "http://www.airproducts.de",
            contactUs: "https://airproducts-de.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "EC",
            aboutUs: "http://www.indura.com.ec",
            contactUs: "https://www.indura.com.ec/Web/EC/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "ES",
            aboutUs: "http://www.carburos.com",
            contactUs: "https://airproducts-sp.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "FR",
            aboutUs: "http://www.airproducts.fr",
            contactUs: "https://airproducts-fr.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "ID",
            aboutUs: "http://www.airproducts.co.id",
            contactUs: "http://www.airproducts.co.id/contact-us.aspx"
        },
        {
            salesOrgAlias: "IE",
            aboutUs: "http://www.airproducts.ie",
            contactUs: "https://airproducts-uk.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "IL",
            aboutUs: "http://www.airproducts.co.il",
            contactUs: "https://www.airproducts.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "IT",
            aboutUs: "http://www.airproducts.it",
            contactUs: "https://www.airproducts.com/contact-us.aspx"
        },
        {
            salesOrgAlias: "KR",
            aboutUs: "http://www.airproducts.co.kr",
            contactUs: "https://microsites.airproducts.com/kr-contact-us/index.asp"
        },
        {
            salesOrgAlias: "MY",
            aboutUs: "http://www.airproducts.com.my",
            contactUs: "https://www.airproducts.com.my/customer-service"
        },
        {
            salesOrgAlias: "NL",
            aboutUs: "http://www.airproducts.nl",
            contactUs: "https://airproducts-nl.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "OM",
            aboutUs: "http://www.airproducts.me",
            contactUs: "https://www.airproducts.me/contact-us/form"
        },
        {
            salesOrgAlias: "PE",
            aboutUs: "http://www.airproducts.com.pe",
            contactUs: "https://www.airproducts.com.pe/Web/PE/Contacto/Contacto-Y-Csc"
        },
        {
            salesOrgAlias: "PL",
            aboutUs: "http://www.airproducts.pl",
            contactUs: "https://airproducts-pl.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "PT",
            aboutUs: "http://www.gasin.com",
            contactUs: "https://airproducts-pt.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "SG",
            aboutUs: "http://www.airproducts.com.sg",
            contactUs: "http://www.airproducts.com.sg/contact-us.aspx"
        },
        {
            salesOrgAlias: "SK",
            aboutUs: "http://www.airproducts.sk",
            contactUs: "https://airproducts-sk.custhelp.com/app/ask"
        },
        {
            salesOrgAlias: "TW",
            aboutUs: "http://www.airproducts.com.tw",
            contactUs: "http://www.airproducts.com.tw/contact-us.aspx"
        },
        {
            salesOrgAlias: "UK",
            aboutUs: "http://www.airproducts.co.uk",
            contactUs: "https://airproducts-uk.custhelp.com/app/ask"
        }
    ],
    OracleRightNowCountries: ["IE", "UK", "GB", "ES", "PT", "DE", "FR", "NL", "BE", "PL", "CZ", "SK"],
    footerLinkData: [
        {
            salesOrgAlias: "DEFAULT",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products",
            legalNotice: "https://www.airproducts.com/legal-notice",
            privacyNotice: "https://www.airproducts.com/privacy-notice.aspx",
            cookieNotice: "https://www.airproducts.com/cookie-notice"
        },
        {
            salesOrgAlias: "BE|2060",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/showcase/air-products-benelux",
            legalNotice: "https://www.airproducts.be/fr-be/legal-notice",
            privacyNotice: "http://www.airproducts.be/fr/privacy-notice.aspx",
            cookieNotice: "https://www.airproducts.be/fr-be/cookie-notice"
        },
        {
            salesOrgAlias: "BE|2067",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/showcase/air-products-benelux",
            legalNotice: "http://www.airproducts.be/legal-notice",
            privacyNotice: "http://www.airproducts.be/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.be/cookie-notice"
        },
        {
            salesOrgAlias: "CZ",
            facebook: "https://www.facebook.com/airproductsCZSK",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products-cerc-central-europe-cis-russia",
            legalNotice: "http://www.airproducts.cz/legal-notice",
            privacyNotice: "http://www.airproducts.cz/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.cz/cookie-notice"
        },
        {
            salesOrgAlias: "DE",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products-gmbh",
            legalNotice: "http://www.airproducts.de/legal-notice",
            privacyNotice: "http://www.airproducts.de/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.de/cookie-notice"
        },
        {
            salesOrgAlias: "ES",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://twitter.com/Carburos",
            youTube: "https://www.youtube.com/channel/UC-sl5jZu_9nM1E9xT1uE0ig",
            linkedIn: "https://www.linkedin.com/company/carburos-metalicos",
            legalNotice: "http://www.carburos.com/legal-notice",
            privacyNotice: "http://www.carburos.com/privacy-notice.aspx",
            cookieNotice: "http://www.carburos.com/cookie-notice"
        },
        {
            salesOrgAlias: "FR",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products-france",
            legalNotice: "http://www.airproducts.fr/legal-notice",
            privacyNotice: "http://www.airproducts.fr/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.fr/cookie-notice"
        },
        {
            salesOrgAlias: "IE",
            facebook: "https://www.facebook.com/airproductsuki",
            twitter: "https://www.twitter.com/airproductsuki",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products",
            legalNotice: "https://www.airproducts.ie/legal-notice",
            privacyNotice: "http://www.airproducts.ie/privacy-notice.aspx",
            cookieNotice: "https://www.airproducts.ie/cookie-notice"
        },
        {
            salesOrgAlias: "NL",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/showcase/air-products-benelux",
            legalNotice: "http://www.airproducts.nl/legal-notice",
            privacyNotice: "http://www.airproducts.nl/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.nl/cookie-notice"
        },
        {
            salesOrgAlias: "PL",
            facebook: "https://www.facebook.com/airproductspoland",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products-cerc-central-europe-cis-russia",
            legalNotice: "http://www.airproducts.com.pl/legal-notice",
            privacyNotice: "http://www.airproducts.com.pl/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.com.pl/cookie-notice"
        },
        {
            salesOrgAlias: "PT",
            facebook: "https://www.facebook.com/airproductscareers",
            twitter: "https://twitter.com/Gasin_PT",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products",
            legalNotice: "http://www.gasin.com/legal-notice",
            privacyNotice: "http://www.gasin.com/privacy-notice.aspx",
            cookieNotice: "http://www.gasin.com/cookie-notice"
        },
        {
            salesOrgAlias: "SK",
            facebook: "https://www.facebook.com/airproductsCZSK",
            twitter: "https://www.twitter.com/AirProducts",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products-cerc-central-europe-cis-russia",
            legalNotice: "http://www.airproducts.sk/legal-notice",
            privacyNotice: "http://www.airproducts.sk/privacy-notice.aspx",
            cookieNotice: "http://www.airproducts.sk/cookie-notice"
        },
        {
            salesOrgAlias: "UK",
            facebook: "https://www.facebook.com/airproductsuki",
            twitter: "https://www.twitter.com/airproductsuki",
            youTube: "https://www.youtube.com/airproducts",
            linkedIn: "https://www.linkedin.com/company/air-products",
            legalNotice: "https://www.airproducts.co.uk/legal-notice",
            privacyNotice: "https://www.airproducts.co.uk/privacy-notice",
            cookieNotice: "https://www.airproducts.co.uk/cookie-notice"
        }
    ],
    countryCurrency:[
        {
            //IE, FR, DE, NL, BE, ES, PT, SK
            salesOrgAlias: "DEFAULT",
            code: "EUR"
        },
        {
            salesOrgAlias: "UK",
            code: "GBP"
        },
        {
            salesOrgAlias: "CZ",
            code: "CZK"
        },
        {
            salesOrgAlias: "PL",
            code: "PLN"
        },
        {
            salesOrgAlias: "US",
            code: "USD"
        },
        {
            salesOrgAlias: "CN",
            code: "CNY"
        }
    ],
    prospectCountries:["BE","ES","FR","UK","IE","NL","PT"],
    contactUsMailForMoreThan10Cyls:[
        {
            country: "BE",
            email: "beinfo@airproducts.com"
        },
        {
            country: "UK",
            email: "APUKINFO@airproducts.com"
        },
        {
            country: "IE",
            email: "APUKINFO@airproducts.com"
        },
        {
            country: "DE",
            email: "vertrieb@airproducts.de"
        },
        {
            country: "FR",
            email: "CCDF@airproducts.com"
        },
        {
            country: "NL",
            email: "nlinfo@Airproducts.com"
        },
        {
            country: "ES",
            email: "oferta@airproducts.com"
        },
        {
            country: "PT",
            email: "proposta@gasin.com"
        }
    ]
};